/*
  WhackSports PDP photo urgency badges (theme replacement for ConvertCart #86488486).
  Vanilla JS — uses Shopify variant inventory, localization country, and currency APIs.
*/
(function () {
  if (window.__wsPhotoBadgesInit) return;
  window.__wsPhotoBadgesInit = true;

  var BULKY_PRODUCT_PATHS = [
    '/products/aero-pugg-goal-6-foot',
    '/products/thirdman-reflex-net',
    '/products/sg-rp-premium-wheelie-kit-bag-hw',
    '/products/gn-legend-gn-10-wheelie-kit-bag-hh',
    '/products/gray-nicolls-gn-2000-cricket-kit-bag-wheelie-large',
    '/products/gray-nicolls-legend-gold-cricket-kit-bag-wheelie-large',
    '/products/sklz-bat-a-way-pts',
    '/products/sklz-hurricane-category-4',
    '/products/ultimate-3d-trainer-bundle',
    '/products/sklz-cricket-pop-up-stumps-net',
    '/products/sklz-home-range-golf-net'
  ];

  var PRODUCT_TYPE_TO_CATEGORY = {
    'EW Bat': 'bats',
    'KW Bat': 'bats',
    'Batting Gloves': 'gloves',
    'Batting Inner': 'gloves',
    'Batting Pads': 'pads',
    'Kit Bag': 'bags',
    'Cricket Shoes': 'shoes',
    'Cricket Helmet': 'helmets',
    'Chest Guard': 'protective',
    'Cricket Protective': 'protective',
    'Mouth Guard': 'protective',
    'Thigh Pads': 'protective',
    'Rugby Headgear': 'protective',
    'Rugby Shoulder Pads': 'protective',
    'Keeping Gloves': 'keeping',
    'Keeping Inner': 'keeping',
    'Keeping Pads': 'keeping'
  };

  var stockCount = 0;
  var rotationInterval = null;
  var rotationMode = 'stock';
  var usdConversionRate = null;
  var parsedShopifyRates = null;
  var productConfig = null;
  var variantsById = null;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function getCountryCode() {
    return (document.documentElement.getAttribute('data-coun') || '').toUpperCase();
  }

  function getProductConfig() {
    if (productConfig) return productConfig;
    var el = qs('[data-ws-photo-badges-config]');
    if (!el) return null;
    try {
      productConfig = JSON.parse(el.textContent);
    } catch (e) {
      productConfig = {};
    }
    return productConfig;
  }

  function getVariantsById() {
    if (variantsById) return variantsById;
    variantsById = {};
    var textarea = qs('[data-variant-json]');
    if (!textarea) return variantsById;
    try {
      var variants = JSON.parse(textarea.textContent);
      if (Array.isArray(variants)) {
        variants.forEach(function (variant) {
          variantsById[String(variant.id)] = variant;
        });
      }
    } catch (e) {
      variantsById = {};
    }
    return variantsById;
  }

  function getCurrentVariantId() {
    var select = qs('form.product-single__form select[name="id"]');
    if (select && select.value) return select.value;
    var input = qs('form.product-single__form input[name="id"]');
    if (input && input.value) return input.value;
    var productIdInput = qs('form.product-single__form input[name="product-id"]');
    if (productIdInput && productIdInput.value) return productIdInput.value;
    return '';
  }

  function getCurrentVariant() {
    var id = getCurrentVariantId();
    if (!id) return null;
    return getVariantsById()[String(id)] || null;
  }

  function getPriceInUSD(displayedPrice) {
    var shopifyCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency : {};
    var activeCurrency = shopifyCurrency.active || 'AUD';
    var currentRate = parseFloat(shopifyCurrency.rate) || 1.0;

    if (activeCurrency === 'AUD') {
      return Math.round(displayedPrice);
    }
    if (activeCurrency === 'NZD') {
      return Math.round(displayedPrice / currentRate);
    }
    if (activeCurrency === 'USD') {
      return Math.round(displayedPrice);
    }
    if (parsedShopifyRates && parsedShopifyRates[activeCurrency]) {
      return Math.round(displayedPrice * parsedShopifyRates[activeCurrency]);
    }
    var convertPrice = displayedPrice / currentRate;
    var rate = usdConversionRate || 0.66;
    return Math.round(convertPrice * rate);
  }

  function extractProductPrice() {
    var variant = getCurrentVariant();
    if (variant && variant.price !== undefined) {
      return Number(variant.price) / 100;
    }
    return 0;
  }

  function extractStockCount() {
    var variant = getCurrentVariant();
    if (!variant) return 0;
    if (variant.inventory_management !== 'shopify') return 0;
    return Number(variant.inventory_quantity) || 0;
  }

  function getThresholdValue() {
    var config = getProductConfig() || {};
    var url = window.location.pathname.toLowerCase();
    var productType = config.type || '';
    var category = '';

    if (productType && PRODUCT_TYPE_TO_CATEGORY[productType]) {
      category = PRODUCT_TYPE_TO_CATEGORY[productType];
    } else if (url.indexOf('bat') !== -1 || url.indexOf('keeping') !== -1) {
      category = 'bats';
    } else if (url.indexOf('gloves') !== -1) {
      category = 'gloves';
    } else if (url.indexOf('pads') !== -1 || url.indexOf('bag') !== -1) {
      category = 'pads';
    } else if (url.indexOf('shoes') !== -1 || url.indexOf('thigh') !== -1) {
      category = 'shoes';
    }

    if (category === 'bats' || url.indexOf('keeping') !== -1) {
      return 5;
    }
    if (category === 'gloves') {
      return 15;
    }
    if (category === 'pads' || category === 'bags') {
      return 10;
    }
    if (category === 'shoes' || url.indexOf('thigh') !== -1) {
      return 20;
    }
    if (productType === 'Cricket Helmet' || url.indexOf('helmet') !== -1) {
      var price = extractProductPrice();
      var priceUSD = getPriceInUSD(price);
      if (priceUSD >= 350) {
        return 5;
      }
      if (priceUSD >= 175 && priceUSD <= 300) {
        return 10;
      }
      if (priceUSD < 175) {
        return 20;
      }
      return 10;
    }
    return null;
  }

  function isBulkyProduct() {
    var currentPath = window.location.pathname.toLowerCase();
    return BULKY_PRODUCT_PATHS.some(function (path) {
      return currentPath.indexOf(path.toLowerCase()) !== -1;
    });
  }

  function nudgeBestsellerBadge() {
    setTimeout(function () {
      var badge = qs('.ct-product-bestseller-badge-main');
      if (badge) badge.classList.add('ccChangePosition8486');
    }, 10);
  }

  function loadCurrencyRates() {
    if (parsedShopifyRates) {
      return Promise.resolve(parsedShopifyRates);
    }
    return fetch('https://cdn.shopify.com/s/javascripts/currencies.js')
      .then(function (res) {
        return res.text();
      })
      .then(function (res) {
        try {
          var startIdx = res.indexOf('rates:{') + 6;
          var endIdx = res.indexOf('}', startIdx) + 1;
          if (startIdx > 5 && endIdx > 0) {
            var rawRatesText = res.slice(startIdx, endIdx);
            var jsonFormat = rawRatesText.replace(/([a-zA-Z0-9_]+):/g, '"$1":').replace(/:(\.[0-9]+)/g, ':0$1');
            parsedShopifyRates = JSON.parse(jsonFormat);
          }
          var arr1 = res.split('AUD:')[1];
          var arr2 = arr1.split(',')[0];
          usdConversionRate = parseFloat(arr2);
        } catch (e) {
          usdConversionRate = 0.66;
        }
        return parsedShopifyRates;
      })
      .catch(function () {
        usdConversionRate = 0.66;
        return null;
      });
  }

  function isEligibleForFreeShipping() {
    var countryCode = getCountryCode();
    var price = extractProductPrice();
    if (price === 0) {
      return Promise.resolve(false);
    }

    var isAnz = countryCode === 'AU' || countryCode === 'NZ';
    if (isAnz) {
      var shopifyCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency : {};
      var activeCurrency = shopifyCurrency.active || 'AUD';
      var localPrice = price;
      if (activeCurrency !== 'AUD' && activeCurrency !== 'NZD') {
        var priceUSD = getPriceInUSD(price);
        localPrice = priceUSD / (usdConversionRate || 0.66);
      }
      if (localPrice < 225) {
        return Promise.resolve(false);
      }
    } else {
      var priceUsd = getPriceInUSD(price);
      if (priceUsd < 750) {
        return Promise.resolve(false);
      }
    }

    nudgeBestsellerBadge();
    return Promise.resolve(true);
  }

  function isEligibleForLowStock() {
    var threshold = getThresholdValue();
    return threshold !== null && stockCount > 0 && stockCount <= threshold;
  }

  function isEligibleForKnocking() {
    var config = getProductConfig() || {};
    return config.type === 'EW Bat';
  }

  function stripCcPhotoBadges() {
    if (!document.body.classList.contains('template-product')) return;

    document
      .querySelectorAll(
        '.cc-sp-section--86488486:not([data-source="whacksports-theme"]), ' +
          '.cc-knock-section--86488486:not([data-source="whacksports-theme"])'
      )
      .forEach(function (el) {
        el.remove();
      });

    document.querySelectorAll('.product__main-photos .cc-stock-section, .product__main-photos .cc-freeShipping-section').forEach(function (el) {
      var ccRoot = el.closest('.cc-sp-section--86488486');
      if (ccRoot && !ccRoot.matches('[data-source="whacksports-theme"]')) {
        ccRoot.remove();
      }
    });
  }

  function getBadgeRoot() {
    return qs('.ws-photo-badges[data-source="whacksports-theme"]');
  }

  function showKnockingBadge() {
    var knock = qs('.ws-photo-badges__knock[data-source="whacksports-theme"]');
    if (!knock) return;
    if (isEligibleForKnocking()) {
      knock.hidden = false;
      knock.classList.add('is-active');
    } else {
      knock.hidden = true;
      knock.classList.remove('is-active');
    }
  }

  function getBadgeElements() {
    var root = getBadgeRoot();
    if (!root) return { pill: null, textEl: null };
    var pill = root.querySelector('.ws-photo-badges__pill');
    var textEl = pill ? pill.querySelector('.ws-photo-badges__text') : null;
    return { pill: pill, textEl: textEl };
  }

  function setStockLabel(textEl) {
    textEl.replaceChildren();
    textEl.append(document.createTextNode('Low Stock '));
    var divider = document.createElement('span');
    divider.className = 'ws-photo-badges__divider';
    divider.textContent = ' | ';
    textEl.appendChild(divider);
    textEl.append(document.createTextNode(String(stockCount) + ' left'));
  }

  function getShippingLabel(bulky) {
    return bulky ? 'Bulky' : 'Free Shipping';
  }

  function hideBadgePill() {
    var els = getBadgeElements();
    if (!els.pill) return;
    els.pill.classList.remove('is-active');
    els.pill.hidden = true;
    els.pill.removeAttribute('data-mode');
    if (els.textEl) els.textEl.replaceChildren();
  }

  function showBadgePill(mode, bulky) {
    var els = getBadgeElements();
    if (!els.pill || !els.textEl) return;

    els.pill.dataset.mode = mode;
    if (mode === 'stock') {
      setStockLabel(els.textEl);
    } else {
      els.textEl.textContent = getShippingLabel(bulky);
    }

    els.pill.hidden = false;
    els.pill.classList.add('is-active');
  }

  function switchBadgePill(mode, bulky) {
    hideBadgePill();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        showBadgePill(mode, bulky);
      });
    });
  }

  function manageTagsRotation() {
    if (rotationInterval) {
      clearInterval(rotationInterval);
      rotationInterval = null;
    }

    var els = getBadgeElements();
    if (!els.pill || !els.textEl) {
      return;
    }

    var bulky = isBulkyProduct();
    var showStock = isEligibleForLowStock();

    isEligibleForFreeShipping().then(function (showShipping) {
      if (bulky) {
        showShipping = true;
      }

      if (showStock) {
        document.body.classList.add('ccShowCamp8486');
      } else {
        document.body.classList.remove('ccShowCamp8486');
      }

      hideBadgePill();

      if (showStock && showShipping) {
        rotationMode = 'stock';
        showBadgePill('stock', bulky);
        nudgeBestsellerBadge();

        rotationInterval = setInterval(function () {
          rotationMode = rotationMode === 'stock' ? 'shipping' : 'stock';
          switchBadgePill(rotationMode, bulky);
        }, 5000);
      } else if (showStock) {
        showBadgePill('stock', bulky);
      } else if (showShipping) {
        showBadgePill('shipping', bulky);
        nudgeBestsellerBadge();
      }
    });
  }

  function refreshVariantState() {
    stockCount = extractStockCount();
    showKnockingBadge();
    if (getThresholdValue() === null) {
      manageTagsRotation();
      return;
    }
    loadCurrencyRates().then(function () {
      manageTagsRotation();
    });
  }

  function bindEvents() {
    document.addEventListener('variant:change', function () {
      refreshVariantState();
    });

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.matches) return;
        if (t.matches('.variant-input-wrap select') || t.matches('form.product-single__form select[name="id"]')) {
          refreshVariantState();
        }
      },
      false
    );

    document.addEventListener(
      'mousedown',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('.cc-size-button:not(.cc-disabled), .ws-size-button:not(.ws-disabled)') : null;
        if (!btn) return;
        setTimeout(refreshVariantState, 100);
      },
      false
    );

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var btn = e.target && e.target.closest ? e.target.closest('.cc-size-button:not(.cc-disabled), .ws-size-button:not(.ws-disabled)') : null;
        if (!btn) return;
        setTimeout(refreshVariantState, 100);
      },
      false
    );
  }

  function boot() {
    stripCcPhotoBadges();
    if (!getBadgeRoot()) return;
    bindEvents();
    refreshVariantState();

    if (document.body) {
      new MutationObserver(stripCcPhotoBadges).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
